import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Loader2 } from 'lucide-react';

export default function EditTargetModal({ open, onClose, target, editForm, setEditForm, onSave, submitting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit Target - {target?.sku_code}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Target Price (USD)</Label>
            <Input type="number" step="0.01" value={editForm.target_price_usd} onChange={(e) => setEditForm(f => ({ ...f, target_price_usd: e.target.value }))} className="rounded-sm font-mono" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Expected Qty</Label>
              <Input type="number" value={editForm.expected_qty_for_period} onChange={(e) => setEditForm(f => ({ ...f, expected_qty_for_period: e.target.value }))} className="rounded-sm font-mono" />
            </div>
            <div className="space-y-2">
              <Label>Effective Date</Label>
              <Input type="date" value={editForm.effective_date} onChange={(e) => setEditForm(f => ({ ...f, effective_date: e.target.value }))} className="rounded-sm" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Input value={editForm.notes} onChange={(e) => setEditForm(f => ({ ...f, notes: e.target.value }))} className="rounded-sm" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">Cancel</Button>
          <Button onClick={onSave} disabled={submitting} className="rounded-sm">
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save Changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
